import { TimelineMax, Expo } from 'gsap';

import hades from '@/scripts/hades';

export function motorcycleIn(el, done) {
  const tl = new TimelineMax({
    onComplete: done,
  });

  tl.set(el, {
    autoAlpha: 1,
  });

  return tl;
}

export function motorcycleOut(el, done) {
  const tl = new TimelineMax({
    onComplete: () => {
      hades.ref.play();
      done();
    },
  });

  const figure = el.querySelector('.slider__figure');
  const img = el.querySelector('.slider__img');
  const items = Array.from(el.querySelectorAll('.slider__item h1'));
  const { left } = document.querySelector('.slider').getBoundingClientRect();
  const filler = el.querySelector('.slider__filler');

  tl
    .add('start')
    .set(el, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100vw',
      zIndex: 10,
    }, 'start')
    .to(figure, 2, {
      left: left * -1,
      top: 0,
      autoAlpha: 1,
      width: window.innerWidth,
      height: window.innerHeight,
      ease: Expo.easeInOut,
    }, 'start')
    .to(img, 2, {
      attr: {
        width: window.innerWidth,
        height: window.innerHeight,
        x: 0,
        y: 0,
      },
      ease: Expo.easeInOut,
    }, 'start')
    .to(filler, 2, {
      autoAlpha: 0.3,
      ease: Expo.easeInOut,
    }, 'start')
    .to(items, 2, {
      autoAlpha: 0,
      yPercent: 100,
      ease: Expo.easeOut,
    }, 'start');

  return tl;
}
